export default {
  actions: 'Actions',
  view: 'View',
  edit: 'Edit',
  delete: 'Delete',
};
